import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Components
 */

import { TestModalComponent } from '.';

/**
 * Services
 */

import { ModalMockService } from '.';
import { ComponentResolverMockService } from '.';
export class TestModalModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  providers: [
    ModalMockService,
    ComponentResolverMockService
  ],
  declarations: [
    TestModalComponent
  ],
  entryComponents: [
    TestModalComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TestModalModule_tsickle_Closure_declarations() {
/** @type {?} */
TestModalModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TestModalModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
